import { ColorPickerIcon } from "@hugeicons/core-free-icons";
import { HugeiconsIcon } from "@hugeicons/react";
import { useState } from "react";
import { useFormikContext } from "formik";
import useEyeDropper from "use-eye-dropper";
import { Stack, IconButton, Popover } from "@mui/material";
import OrganizationSetting from "./Setting";
import { HexColorInput, HexAlphaColorPicker } from "react-colorful";
import { Color } from '@/components';
import get from "lodash/get";

interface Context {
  primaryColor: string;
  secondaryColor: string;
}

interface Props {
  field: string;
  title: string;
  description: string;
}

const ColorSetting = ({ field, title, description }: Props) => {
    const eyeDropper = useEyeDropper();
    const { values, setFieldValue } = useFormikContext<Context>();
    const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
    const open = Boolean(anchorEl);

    return (
        <OrganizationSetting
            title={title}
            description={description}
          >
            <Stack
              spacing={2}
              direction={'row'}
              alignItems={'center'}
              justifyContent={'flex-end'}
            >
              
              <Color value={get(values, field, '#000')} size="small" />

              {eyeDropper.isSupported() ? (
                <IconButton
                  onClick={() => {
                    eyeDropper.open().then((color) => {
                      setFieldValue(field, color.sRGBHex);
                    });
                  }}
                >
                  <HugeiconsIcon icon={ColorPickerIcon} color="black" />
                </IconButton>
              ) : null}

              <Popover
                open={open}
                anchorEl={anchorEl}
                onClose={() => setAnchorEl(null)}
              >
                <HexAlphaColorPicker
                  color={get(values, field, '#000')}
                  onChange={(color: any) => {
                    setFieldValue(field, color);
                  }}
                />
                <HexColorInput
                  alpha
                  prefixed
                  color={get(values, field, '#000')}
                  onChange={(color) =>
                    setFieldValue('primaryColor', color)
                  }
                />
              </Popover>
            </Stack>
          </OrganizationSetting>
    )
}

export default ColorSetting;
